import { Component, output, signal } from '@angular/core';
import { NgFor, NgIf } from '@angular/common';

@Component({
  selector: 'mce-table-grid-picker',
  standalone: true,
  imports: [NgFor, NgIf],
  templateUrl: './table-grid-picker.component.html',
  styleUrl: './table-grid-picker.component.scss',
})
export class TableGridPickerComponent {
  readonly tableSelected = output<{ rows: number; cols: number }>();

  readonly ROWS = 8;
  readonly COLS = 8;
  readonly rows = Array.from({ length: this.ROWS }, (_, i) => i + 1);
  readonly cols = Array.from({ length: this.COLS }, (_, i) => i + 1);

  readonly hoverRow = signal(0);
  readonly hoverCol = signal(0);

  onCellHover(row: number, col: number) {
    this.hoverRow.set(row);
    this.hoverCol.set(col);
  }

  onCellLeave() {
    this.hoverRow.set(0);
    this.hoverCol.set(0);
  }

  onCellClick(row: number, col: number, event: MouseEvent) {
    event.stopPropagation();
    this.tableSelected.emit({ rows: row, cols: col });
  }

  isHighlighted(row: number, col: number): boolean {
    return row <= this.hoverRow() && col <= this.hoverCol();
  }
}
